import { createVuetify } from 'vuetify'
import type { ThemeDefinition } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import '@mdi/font/css/materialdesignicons.css' // ⬅️ 아이콘 폰트 CSS 추가

// TODO: Light 테마 색상 설정 (취향대로)
const LightTheme: ThemeDefinition = {
	dark: false,
	variables: {},
	colors: {
		primary: '#1976D2',
		secondary: '#424242',
		accent: '#82B1FF',
		error: '#FF5252',
		info: '#2196F3',
		success: '#4CAF50',
		warning: '#FFC107',
		onSurface: '#000000'
	}
}

const DarkTheme: ThemeDefinition = {
	dark: true,
	variables: {},
	colors: {
		primary: '#1976D2',
		secondary: '#424242',
		accent: '#82B1FF',
		error: '#FF5252',
		info: '#2196F3',
		success: '#4CAF50',
		warning: '#FFC107',
		onSurface: '#FFFFFF'
	}
}

// TODO: Nuxt3 vuetify plugin 설정
export default defineNuxtPlugin((NuxtApp) => {
	const vuetify = createVuetify({
		components,
		directives,
		theme: {  // 테마 설정
			themes: {
				light: LightTheme,
				dark: DarkTheme,
				variables: {}
			}
		},
		icons: { // 아이콘 설정
			defaultSet: 'mdi',
			aliases,
			sets: {
				mdi
			}
		}
	})

	NuxtApp.vueApp.use(vuetify)
})